import React from 'react'
import {
    Link,
  } from "react-router-dom";
  
export const PosSoftware = (props) => {
    return (
        <div>
            <div className="container">

                <h3 className="mt-4 mb-3">BronzeTag POS Software
            
                </h3>

                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                        {/* <a href="index.html">Home</a> */}
                    </li>
                    <li className="breadcrumb-item active">Point of sale</li>
                </ol>

                <div className="row">
                    <div className="col-lg-12">
                        <p>BronzeTag POS offers multiple interfaces for order entry, invoicing and POS sales including a tabular interface with advanced product lookup features for the expert user, and a touch POS interface for a more controlled experience. The complete POS syste can be downloaded from the link below.</p>
                        <Link to="download">Downloads</Link>
                        
                    </div>
                
                </div>
            
            </div>

            <div className="container">
    

  </div>
        </div>
    )
}